module.exports = __webpack_public_path__ + "img/撤销3.a5a6fcc9.svg";